export default __webpack_public_path__ + "static/media/live-feed-open.2e42d89e.svg";